
















































































































/**
 * @copyright       Palace Resorts
 * @description     Pantalla principal de Reportes
 * @author          cchan
 * @creationDate    20/09/2021
 */

import i18nMessages from "./i18n/messages";
import GlobalMixin from "@/mixins/global";
import ResponseData from "@/models/store/ProveedoresTypesData";
import dataService from "@/services/proveedoresAPI";
import BreadcrumbNav from "@/components/Breadcrumbs/BreadcrumbNav.vue";
import DatatableReport from "@/components/Reports/DatatableReport.vue";
export default GlobalMixin.extend({
  // Asignamos los mensajes del módulo al framework i18n, para el manejo del idioma
  i18n: i18nMessages,
  components: {
    // Incluimos lo componentes que utilizará este módulo
    BreadcrumbNav,
    DatatableReport,
  },
  data() {
    return {
      // GENERAL
      moduleName: "REPORTS",
      // TABS
      tab: null,
      // total pendientes por subir
      totalP: 0,
      // total pendientes por autorizar
      totalPA: 0,
      // total rechazados
      totalR: 0,
      // AUTOCOMPLETE
      supplier: null as any,
      supplierOptions: [] as any,
      search: "",
      loadingSuppliers: false,
      isLoading: false,
      // DATATABLES
      // pendientes por subir
      headersMissingDoc: [],
      dataTableMissingDoc: [],
      loadingMissingDoc: true,
      // pendientes por autorizar
      headersPendingDoc: [],
      dataTablePendingDoc: [],
      loadingPendingDoc: true,
      // rechazados
      headersRefuseDoc: [],
      dataTableRefuseDoc: [],
      loadingRefuseDoc: true,
    };
  },
  methods: {
    // GENERAL
    init() {
      // Pendientes por subir
      this.headersMissingDoc = [
        {
          text: "Proveedor",
          align: "start",
          value: "proveedor",
          filter: this.getfilterProveedor,
        },
        {
          text: "Tipo de documento",
          value: "docTipo",
        },
      ];
      // Pendientes por autorizar
      this.headersPendingDoc = [
        {
          text: "Proveedor",
          align: "start",
          value: "proveedor",
          filter: this.getfilterProveedor,
        },
        {
          text: "Tipo de documento",
          value: "docTipo",
        },
      ];
      // Rechazados
      this.headersRefuseDoc = [
        {
          text: "Proveedor",
          align: "start",
          value: "proveedor",
          filter: this.getfilterProveedor,
        },
        {
          text: "Tipo de documento",
          value: "docTipo",
        },
        {
          text: "Motivo de Rechazo",
          value: "docMotivoRechazo",
        },
      ];
      // Proveedores con pendientes por subir
      //this.getReportMissingDoc()
      // Proveedores con pendientes por autorizar
      this.getReportPendingDoc()
      // Proveedores con documentos rechazados
      this.getReportRefuseDoc()
    },
    // Lista de Proveedores
    async getdata(val: any) {
      dataService
        .getAllProvider(0, 10, val)
        .then((Response: ResponseData) => {
          this.supplierOptions = Response.data.data[0].data[0];
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => (this.isLoading = false));
    },
    // Reporte de proveedores con documentos pendientes por subir
    async getReportMissingDoc() {
      dataService
        .getReportMissingDoc()
        .then((Response: ResponseData) => {
          this.totalP = Response.data.data[0].totalProveedores
          this.dataTableMissingDoc = Response.data.data[0].listaProveedores
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => (this.loadingMissingDoc = false));
    },
    // Reporte de proveedores con documentos pendientes por autorizar
    async getReportPendingDoc() {
      dataService
        .getReportPendingDoc()
        .then((Response: ResponseData) => {
          this.totalPA = Response.data.data[0].totalProveedores
          this.dataTablePendingDoc = Response.data.data[0].listaProveedores
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => (this.loadingPendingDoc = false));
    },
    // Reporte de proveedores con documentos rechazados
    async getReportRefuseDoc() {
      dataService
        .getReportRefuseDoc()
        .then((Response: ResponseData) => {
          this.totalR = Response.data.data[0].totalProveedores
          this.dataTableRefuseDoc = Response.data.data[0].listaProveedores
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => (this.loadingRefuseDoc = false));
    },
    // FILTROS
    getfilterProveedor(value: any) {
      // If this filter has no value we just skip the entire filter.
      if (!this.supplier) {
        return true;
      }
      let noProveedor = this.supplier.userID;
      let values = value.toString();
      return values.toLowerCase().includes(noProveedor.toLowerCase());
    },
    filterFuncion(item: any, queryText: any, itemText: any) {
      return (
        item.userID.toLowerCase().includes(queryText.toLowerCase()) ||
        item.userName.toLowerCase().includes(queryText.toLowerCase())
      );
    },
  },
  watch: {
    search(val: string) {
      // Items have already been requested
      if (this.isLoading) return;
      this.isLoading = true;
      this.getdata(val);
    },
  },
  mounted() {
    this.init();
  },
});
